if (!customElements.get('product-gallery')) {
  class ProductGallery extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.isZoomed = false
      this.closeButton = this.querySelector('.js-gallery-close')
      this.init()

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.closeGallery())
      }

      // For testing purposes
      // Listen for a custom event when the property is set
      window.addEventListener('test-zoom-gallery-changed', () => {
        if (window['test-zoom-gallery'] === true && window.innerWidth < 768) {
          this.zoomGallery(0);
        }
      });

      // Check immediately in case it's already set
      if (window['test-zoom-gallery'] === true && window.innerWidth < 768) {
        this.zoomGallery(0);
      }
    }

    init() {
      const swiperElement = this.querySelector('.js-swiper')
      const swiperNextButton = this.querySelector('.js-swiper-button-next')
      const swiperPrevButton = this.querySelector('.js-swiper-button-prev')

      if (!swiperElement) return

      this.swiper = new Swiper(swiperElement, {
        slidesPerView: this.dataset.mobileDefaultZoom === 'true' ? 1 : 2,
        spaceBetween: 2,
        loop: true,
        navigation: {
          nextEl: swiperNextButton,
          prevEl: swiperPrevButton,
        },
        breakpoints: {
          768: {
            slidesPerView: 1,
          },
          1200: {
            slidesPerView: 2,
          },
        },
        on: {
          afterInit: () => {
            this.classList.remove('loading')
            setTimeout(() => {
              swiperPrevButton.classList.remove('loading')
              swiperNextButton.classList.remove('loading')
            }, 100)
          },
          click: () => {
            if (this.dataset.disableZoom === 'true') return
            this.zoomGallery()
          },
        },
      })
    }

    zoomGallery(index = null) {
      let clickedSlide = this.swiper.clickedSlide
      let clickedIndex = this.swiper.clickedIndex
      if (index !== null && index >= 0) {
        clickedSlide = this.querySelector('.js-swiper').querySelectorAll('.swiper-slide')[index]
        clickedIndex = index
      }

      if (!clickedSlide) return

      // Only enable zoom if currently slidesPerView is 2
      if (this.swiper.params.slidesPerView === 2) {
        this.swiper.originalIndex = this.swiper.activeIndex
        this.swiper.params.slidesPerView = 1
        this.swiper.update()
        this.swiper.slideTo(clickedIndex, 0)
        this.closeButton.classList.remove('visually-hidden')
        this.isZoomed = true
      } else {
        if (this.isZoomed) {
          this.closeGallery()
        }
      }
    }

    closeGallery() {
      const galleryClose = this.querySelector('.js-gallery-close')
      if (!this.swiper) return

      if (this.swiper.params.slidesPerView === 1) {
        this.swiper.params.slidesPerView = 2
        this.swiper.update()
        this.isZoomed = false

        if (typeof this.swiper.originalIndex === 'number') {
          this.swiper.slideTo(this.swiper.originalIndex, 0)
        }

        galleryClose.classList.add('visually-hidden')
      }
    }

    updateGallery(newContent) {
      if (!this.swiper) return

      // Store current state
      const wasZoomed = this.isZoomed
      const currentIndex = this.swiper.activeIndex
      const currentSlidesPerView = this.swiper.params.slidesPerView

      // Update content
      const swiperWrapper = this.querySelector('.swiper-wrapper')
      if (swiperWrapper) {
        swiperWrapper.innerHTML = newContent.querySelector('.swiper-wrapper').innerHTML

        // Play any videos in the new slides
        swiperWrapper.querySelectorAll('video').forEach((video) => {
          video.play().catch((error) => {
            console.warn('Video autoplay failed:', error)
          })
        })
      }

      // Destroy and reinitialize with same configuration
      this.swiper.destroy(true, true)
      this.init()

      // Restore previous state
      if (this.swiper) {
        if (wasZoomed) {
          this.swiper.params.slidesPerView = 1
          this.querySelector('.js-gallery-close')?.classList.remove('visually-hidden')
        } else {
          this.swiper.params.slidesPerView = currentSlidesPerView
        }
        this.swiper.update()
        this.swiper.slideTo(currentIndex, 0)
      }
    }

    updateGalleryMedia(mediaArray) {
      if (!this.swiper) return
      // Store current state
      const wasZoomed = this.isZoomed
      // const currentIndex = this.swiper.activeIndex
      const currentSlidesPerView = this.swiper.params.slidesPerView

      // Disable loop temporarily
      this.swiper.params.loop = false
      this.swiper.update()

      // Update content
      const swiperWrapper = this.querySelector('.swiper-wrapper')
      if (swiperWrapper) {
        // Get current carousel video if it exists
        const currentCarouselVideo = this.querySelector('.js-carousel-video')

        // Convert media array to slides HTML
        let slidesHtml = mediaArray.map((media) => {
          if (media.media_type === 'video') {
            return `
              <li class="swiper-slide">
                <div class="pdp__gallery-image">
                  <video autoplay loop muted playsinline src="${media.src}"></video>
                </div>
              </li>
            `
          } else {
            return `
              <li class="swiper-slide">
                <div class="pdp__gallery-image">
                  <img src="${media.src}&width=1000" alt="${media.alt || ''}" loading="eager">
                </div>
              </li>
            `
          }
        })

        // Create a temporary container
        const tempContainer = document.createElement('div')
        tempContainer.innerHTML = slidesHtml.join('')

        // Get carousel videos from jsonData
        const productInfo = this.closest('product-info')
        if (productInfo?.jsonData?.carousel_videos && currentCarouselVideo) {
          const video_position = Number(productInfo.jsonData.carousel_videos.video_position)
          // If we have a current carousel video and a valid position, keep it in place
          if (video_position) {
            // Insert the actual DOM element at the right position
            const slides = Array.from(tempContainer.children)
            slides.splice(video_position, 0, currentCarouselVideo)
            // Clear and append all slides
            swiperWrapper.innerHTML = ''
            slides.forEach((slide) => swiperWrapper.appendChild(slide))
          } else {
            swiperWrapper.innerHTML = slidesHtml.join('')
          }
        } else {
          swiperWrapper.innerHTML = slidesHtml.join('')
        }

        // Play any NEW videos in the slides (skip the carousel video)
        swiperWrapper.querySelectorAll('video:not(.js-carousel-video video)').forEach((video) => {
          if (!video.playing) {
            video.play().catch((error) => {
              console.warn('Video autoplay failed:', error)
            })
          }
        })
      }

      // Destroy and reinitialize with same configuration
      this.swiper.destroy(true, true)
      this.init()

      // Restore previous state
      if (this.swiper) {
        if (wasZoomed) {
          this.swiper.params.slidesPerView = 1
          this.querySelector('.js-gallery-close')?.classList.remove('visually-hidden')
        } else {
          this.swiper.params.slidesPerView = currentSlidesPerView
        }

        // Re-enable loop and update
        this.swiper.params.loop = true
        this.swiper.update()
        // this.swiper.slideTo(currentIndex, 0)
      }
    }
  }
  customElements.define('product-gallery', ProductGallery)
}
